/* eslint-disable dot-notation */
import { Order } from 'blockly/javascript'

export function registerMotionGenerators(gen) {
  gen.forBlock['motion_move_right'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    const pixel = block.getFieldValue('PIXEL') || 50
    return `window.__PHASER_SPRITES__['${sprite}'].x += ${pixel};\n`
  }

  gen.forBlock['motion_move_left'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    const pixel = block.getFieldValue('PIXEL') || 50
    return `window.__PHASER_SPRITES__['${sprite}'].x -= ${pixel};\n`
  }

  gen.forBlock['motion_move_up'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    const pixel = block.getFieldValue('PIXEL') || 50
    return `window.__PHASER_SPRITES__['${sprite}'].y -= ${pixel};\n`
  }

  gen.forBlock['motion_move_down'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    const pixel = block.getFieldValue('PIXEL') || 50
    return `window.__PHASER_SPRITES__['${sprite}'].y += ${pixel};\n`
  }

  gen.forBlock['motion_jump'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    return `window.__PHASER_SPRITES__['${sprite}'].jump();\n`
  }

  gen.forBlock['motion_goto'] = function (block, generator) {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    const x = generator.valueToCode(block, 'X', Order.ATOMIC) || '0'
    const y = generator.valueToCode(block, 'Y', Order.ATOMIC) || '0'
    return (
      `window.__PHASER_SPRITES__['${sprite}'].x = ${x}; ` +
      `window.__PHASER_SPRITES__['${sprite}'].y = ${y};\n`
    )
  }

  gen.forBlock['math_random'] = (block) => {
    let min = Number(block.getFieldValue('MIN') || 0)
    let max = Number(block.getFieldValue('MAX') || 100)
    if (min > max) {
      const tmp = min
      min = max
      max = tmp
    }
    return [`Math.floor(Math.random() * (${max} - ${min} + 1)) + ${min}`, Order.FUNCTION_CALL]
  }

  gen.forBlock['math_number'] = (block) => {
    const num = Number(block.getFieldValue('NUM'))
    return [String(num), Order.ATOMIC]
  }

  gen.forBlock['sprite_ref'] = (block) => {
    const name = block.getFieldValue('SPRITE') || 'kiko'
    return [`'${name}'`, Order.ATOMIC]
  }
}
